<form>
  <div hlmFieldGroup>
    <fieldset hlmFieldSet>
      <div class="2-3/4">
        <legend hlmFieldLegend>5. Supports</legend>
        <p hlmFieldDescription>Sélectionnez les supports d’activité qui pourront servir de guide aux formateurs.</p>
      </div>

      <div class="gap-lg grid">
        @for (supportForm of formService().supports.controls; track $index; let idx = $index) {
          <app-expansion-panel [titre]="'Support ' + (idx + 1)" [isOpen]="true" [item]="idx" [actions]="supportActions">
            <div class="m-md gap-md grid w-4/5" [formGroup]="supportForm">
              <div hlmField>
                <label [for]="'input-nom-' + idx" hlmFieldLabel>Nom du support</label>
                <input [id]="'input-nom-' + idx" hlmInput type="text" formControlName="nom" autocomplete="off" />
              </div>
              <div hlmField>
                <label hlmFieldLabel for="'input-lien-' + idx">Lien vers le support</label>
                <input [id]="'input-lien-' + idx" hlmInput type="text" formControlName="lien" inputmode="url" />
                <hlm-field-description>Lien vers le Google Drive qui contient le support.</hlm-field-description>
              </div>
              <div hlmField>
                <label [for]="'select-tags-' + idx" hlmFieldLabel>Tags</label>
                <hlm-select class="inline-block" multiple formControlName="tags">
                  <hlm-select-trigger class="w-full" [id]="'select-tags-' + idx">
                    <hlm-select-value />
                  </hlm-select-trigger>
                  <hlm-select-content>
                    <hlm-option value="evaluation">Évaluation</hlm-option>
                    <hlm-option value="corrigé">Corrigé</hlm-option>
                    <hlm-option value="supportApprenant">Support apprenant</hlm-option>
                    <hlm-option value="supportFormateur">Support formateur</hlm-option>
                  </hlm-select-content>
                </hlm-select>
              </div>
            </div>
          </app-expansion-panel>
        }

        @if (formService().form.enabled) {
          <app-button-add-new (click)="ajouterSupport()" label="Ajouter un support" />
        }
      </div>
    </fieldset>
  </div>
</form>
